/* ---------------------------------------------------
	共通js用
 ----------------------------------------------------- */
$(function(){
	var target = $('a[href^="#"]').not('[target="_blank"]');

	target.click(function(){
		var speed = 500,
			href= $(this).attr('href'),
			target = $(href == "#" || href == "" ? 'html' : href),
			position = target.offset().top;

		$('html, body').animate({scrollTop: position}, speed, 'swing');
		return false;
	});

	var topBtn = $('.l-footer__pageTop');
	topBtn.hide();
	$(window).scroll(function () {
		if ($(this).scrollTop() > 100) {
			topBtn.fadeIn();
		} else {
			topBtn.fadeOut();
		}
	});
	topBtn.click(function () {
		$('body,  html').animate({
			scrollTop: 0
		},   500);
		return false;
	});

	AOS.init();
});